import { useTranslation } from 'react-i18next';
import SolarIcon from 'components/icons/SolarIcon';

interface ShortageHeaderProps {
    title: string;
    hint: string;
    expanded: boolean;
    allMissing: boolean;
    onToggle: () => void;
}

const ShortageHeader = ({
    title,
    hint,
    expanded,
    allMissing,
    onToggle,
}: ShortageHeaderProps) => {
    const { t } = useTranslation(['Objects']);
    const toggleLabel = expanded
        ? t('proposalShortage.btnCollapse')
        : t('proposalShortage.btnExpand');

    return (
        <div className="object-analytics-payments__head">
            <span className="object-analytics-payments__icon" aria-hidden="true">
                <SolarIcon name={allMissing ? 'exclamation-triangle' : 'box-seam'} />
            </span>
            <div className="object-analytics-payments__titles">
                <div className="object-analytics-payments__title-row">
                    <div className="object-analytics-payments__title-stack">
                        <span className="object-analytics-payments__label">{title}</span>
                        <span className="object-analytics-payments__hint">{hint}</span>
                    </div>
                    <button
                        type="button"
                        className="proposal-shortage__toggle-btn"
                        title={toggleLabel}
                        aria-label={toggleLabel}
                        aria-expanded={expanded}
                        onClick={onToggle}
                    >
                        <SolarIcon name={expanded ? 'chevron-up' : 'chevron-down'} aria-hidden="true" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ShortageHeader;
